module.exports = __webpack_public_path__ + "public/img/meningkatkan kemampuan penjualan tenaga pemasaran asuransi-2.095fbacd.png";